import { useState, useEffect, useCallback, useRef } from "react";
import { makeRequest, urlWebSockets } from "../../../../assets/functions_helper";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  Grid,
  IconButton,
  Container,
  MenuItem,
  Drawer,
  Snackbar,
  Alert,
  TextField,
  DialogContentText,
  Divider,
  Badge,
  Menu,
  Slide,
  DialogContent,
  Dialog,
  Backdrop,
  Checkbox
} from "@mui/material";
import { useParams } from "react-router-dom";
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import NotificationsIcon from '@mui/icons-material/Notifications';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import WarningIcon from '@mui/icons-material/Warning';
import imagenLocal from "../../../../assets/images/sections.jpg";
import { ProductCard, OrderProductCard } from "./cards";
import { WorldCupRenderer } from "./world_cup_templates/WorldCupRenderer";
import { WorldCupProductModal } from "./world_cup_templates/WorldCupProductModal";
import { worldCupThemeAssets } from "./world_cup_templates/themeAssets";
import { initGoogleAnalytics } from "../../../../assets/analytics_helper";
import eateryGif from "../../../../assets/images/eatery.gif";
import { useNavigate } from "react-router-dom";
import PromotionalBannerModal from "../../../../components/PromotionalBannerModal";

import {
  CustomDialog,
  CustomDialogTitle,
  CustomDialogContent,
  CustomDialogActions
} from "../../../../components/customDialog";

// Utilidad para convertir hex a rgb (para sombras)
function hexToRgb(hex) {
  hex = hex.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return `${r}, ${g}, ${b}`;
}

// Función para obtener color de contraste (blanco o negro) dado un color de fondo
const getContrastColor = (hex) => {
  if (!hex) return '#ffffff';
  const luma = (() => {
    const c = hex.substring(1);
    const rgb = parseInt(c, 16);
    const r = (rgb >> 16) & 0xff;
    const g = (rgb >> 8) & 0xff;
    const b = (rgb >> 0) & 0xff;
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
  })();
  return luma > 160 ? '#000000' : '#ffffff';
};

// --- HEADER PRINCIPAL (no sticky) ---
const MenuHeader = ({
  menuSections,
  sessionCode,
  onScrollToSection,
  menuConfig,
  logoUrl,
  nameMenu
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedSection, setSelectedSection] = useState("Todo el menú");
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (sectionName) => {
    setAnchorEl(null);
    if (sectionName) {
      setSelectedSection(sectionName);
      onScrollToSection(sectionName);
    }
  };

  return (
    <Box sx={{
      px: { xs: 2, sm: 3 },
      py: 2,
      backgroundColor: menuConfig.header?.background_color || (menuConfig.darkMode ? "#1E1E1E" : "#FFFFFF"),
      borderBottom: menuConfig.darkMode ? '1px solid rgba(255,255,255,0.05)' : '1px solid rgba(0,0,0,0.05)',
    }}>
      {/* Fila superior: logo y código de mesa */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {/* Logo siempre visible con placeholder */}
          <Box
            component="img"
            src={logoUrl || 'https://lh3.googleusercontent.com/aida-public/AB6AXuA6hR82T0AyZSauL044UIYESTK5raRF8lCbtjl6ErjHlqMAd8BiWBKyoeAPV9GlNRrvCwWBDfQOtEZuwaqAGFXYQYSOCTf_U-3YIurTaDdGxZl7gStyZ0iJXCPaJ462zDozm7Z4nJx3JIZ3GJeCr2COM9eH_XAPNt83_8R76ghqMC33jIUtNS5x-c9gYs198vQ1St_kDPGbkyrFzYwUwom5XMlZx8r8qnEeaZ7XKuNFvYwTJrtFIXI-eq2Hd3O9NAe9GsFHD4hcyyY'}
            alt="Logo"
            sx={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              objectFit: 'cover',
              border: menuConfig.darkMode ? '2px solid rgba(255,255,255,0.1)' : '2px solid rgba(0,0,0,0.05)'
            }}
          />
          <Box>
            <Typography variant="caption" sx={{
              color: menuConfig.darkMode ? '#AAAAAA' : '#666666',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '1px',
              fontSize: '0.65rem'
            }}>
              Bienvenido
            </Typography>
            <Typography variant="body1" sx={{
              fontWeight: 700,
              color: menuConfig.header?.text_color || (menuConfig.darkMode ? '#FFFFFF' : '#1A1A1A'),
              fontSize: '1rem'
            }}>
              {nameMenu}
            </Typography>
          </Box>
        </Box>

        {sessionCode && (
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            backgroundColor: menuConfig.tableCode?.background_color || (menuConfig.darkMode ? "rgba(197, 160, 89, 0.1)" : "rgba(197, 160, 89, 0.08)"),
            padding: '6px 16px',
            borderRadius: '50px',
            border: `1px solid ${menuConfig.tableCode?.border_color || "#C5A059"}`,
          }}>
            <Typography variant="caption" sx={{
              color: menuConfig.tableCode?.label_color || (menuConfig.darkMode ? '#AAAAAA' : '#666666'),
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '1px',
              fontSize: '0.65rem'
            }}>
              Mesa
            </Typography>
            <Typography variant="h6" sx={{
              color: menuConfig.tableCode?.number_color || "#C5A059",
              fontWeight: 900,
              fontSize: '1.25rem',
              lineHeight: 1
            }}>
              {sessionCode}
            </Typography>
          </Box>
        )}
      </Box>

      {/* Botón selector de categorías */}
      <Box>
        <Button
          variant="outlined"
          fullWidth
          startIcon={<RestaurantMenuIcon />}
          endIcon={<ExpandMoreIcon />}
          onClick={handleClick}
          sx={{
            justifyContent: 'space-between',
            backgroundColor: menuConfig.filter?.background_color || (menuConfig.darkMode ? '#2A2A2A' : '#F5F5F5'),
            color: menuConfig.filter?.text_color || (menuConfig.darkMode ? '#FFFFFF' : '#1A1A1A'),
            borderColor: menuConfig.darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
            borderRadius: '16px',
            textTransform: 'none',
            fontWeight: 600,
            py: 1.5,
            px: 3,
            '&:hover': {
              borderColor: menuConfig.darkMode ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
              backgroundColor: menuConfig.filter?.background_color || (menuConfig.darkMode ? '#2A2A2A' : '#F5F5F5'),
              transform: 'translateY(-2px)'
            }
          }}
        >
          {selectedSection}
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={() => handleClose()}
          PaperProps={{
            sx: {
              borderRadius: '16px',
              mt: 1,
              boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
              '& .MuiMenuItem-root': {
                fontWeight: 600,
                '&:hover': {
                  backgroundColor: '#f5f5f5'
                },
                '&.Mui-selected': {
                  backgroundColor: menuConfig.filter?.background_color || '#f0f0f0',
                  color: menuConfig.filter?.text_color || '#000'
                }
              }
            }
          }}
        >
          <MenuItem onClick={() => handleClose("Todo el menú")}>Todo el menú</MenuItem>
          {menuSections.map((s) => (
            <MenuItem key={s.name} onClick={() => handleClose(s.name)}>{s.name}</MenuItem>
          ))}
        </Menu>
      </Box>
    </Box>
  );
};

// --- MINI HEADER FLOTANTE (solo select) ---
const MiniHeader = ({ menuSections, onScrollToSection, menuConfig, show }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedSection, setSelectedSection] = useState("Todo el menú");
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (sectionName) => {
    setAnchorEl(null);
    if (sectionName) {
      setSelectedSection(sectionName);
      onScrollToSection(sectionName);
    }
  };

  return (
    <Slide direction="down" in={show} mountOnEnter unmountOnExit>
      <Box sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        backgroundColor: menuConfig.darkMode ? 'rgba(30,30,30,0.9)' : 'rgba(255,255,255,0.9)',
        backdropFilter: 'blur(10px)',
        borderBottom: menuConfig.darkMode ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.05)',
        px: { xs: 2, sm: 3 },
        py: 1.5,
        minHeight: '70px',
        display: 'flex',
        alignItems: 'center'
      }}>
        <Container maxWidth="md" sx={{ px: 0 }}>
          <Button
            variant="outlined"
            fullWidth
            startIcon={<RestaurantMenuIcon />}
            endIcon={<ExpandMoreIcon />}
            onClick={handleClick}
            sx={{
              justifyContent: 'space-between',
              backgroundColor: menuConfig.filter?.background_color || (menuConfig.darkMode ? '#2A2A2A' : '#F5F5F5'),
              color: menuConfig.filter?.text_color || (menuConfig.darkMode ? '#FFFFFF' : '#1A1A1A'),
              borderColor: menuConfig.darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
              borderRadius: '16px',
              textTransform: 'none',
              fontWeight: 600,
              py: 1.2,
              px: 2.5,
              '&:hover': {
                borderColor: menuConfig.darkMode ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
                backgroundColor: menuConfig.filter?.background_color || (menuConfig.darkMode ? '#2A2A2A' : '#F5F5F5'),
              }
            }}
          >
            {selectedSection}
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={() => handleClose()}
            PaperProps={{
              sx: {
                borderRadius: '16px',
                mt: 1,
                boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
                '& .MuiMenuItem-root': {
                  fontWeight: 600,
                  '&:hover': {
                    backgroundColor: '#f5f5f5'
                  },
                  '&.Mui-selected': {
                    backgroundColor: menuConfig.filter?.background_color || '#f0f0f0',
                    color: menuConfig.filter?.text_color || '#000'
                  }
                }
              }
            }}
          >
            <MenuItem onClick={() => handleClose("Todo el menú")}>Todo el menú</MenuItem>
            {menuSections.map((s) => (
              <MenuItem key={s.name} onClick={() => handleClose(s.name)}>{s.name}</MenuItem>
            ))}
          </Menu>
        </Container>
      </Box>
    </Slide>
  );
};

// --- SECCIÓN DEL MENÚ (igual que PreviewSection) ---
const MenuSection = ({ section, onProductSelect, isDarkMode, globalButtonColor }) => {
  const cardType = section.section_type || "default";
  const productBg = isDarkMode ? "#1E1E1E" : "#FFFFFF";
  const productText = isDarkMode ? "#FFFFFF" : "#1A1A1A";
  const buttonColor = section.styles?.buttons_color || globalButtonColor;
  const sectionBackgroundImage = section.background_image_url || imagenLocal;

  return (
    <Box sx={{ mb: 6, px: { xs: 0, sm: 0.5, md: 1 } }}>
      <Box sx={{
        position: 'relative',
        height: '180px',
        borderRadius: '24px',
        overflow: 'hidden',
        mb: 4,
        boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
        '&:hover': { transform: 'scale(1.01)', transition: 'transform 0.3s' }
      }}>
        <Box sx={{
          position: 'absolute',
          inset: 0,
          backgroundImage: `url(${sectionBackgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          zIndex: 1,
          filter: 'brightness(0.8)'
        }} />
        <Box sx={{
          position: 'absolute',
          inset: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          zIndex: 2
        }} />

        <Box sx={{
          position: 'relative',
          zIndex: 3,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          pl: 4,
          pr: 2
        }}>
          <Typography variant="h4" sx={{
            fontWeight: 900,
            color: '#FFFFFF',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            mb: 1
          }}>
            {section.name}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box sx={{ width: '32px', height: '3px', bgcolor: buttonColor || '#C5A059', borderRadius: '2px' }} />
            <Typography variant="caption" sx={{
              color: 'rgba(255,255,255,0.9)',
              fontWeight: 800,
              textTransform: 'uppercase',
              letterSpacing: '1px'
            }}>
              {section.products.length} {section.products.length === 1 ? 'Plato' : 'Platos'}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Grid container spacing={{ xs: 1, sm: 1.5, md: 2 }} sx={{ px: 0 }}>
        {section.products.map((product) => {
          // Determinar qué componente de tarjeta usar basado en si el producto tiene imagen
          const CardComponent = !product.image_url
            ? OrderProductCard               // Sin imagen → tarjeta de solo texto
            : cardType === "default"
              ? ProductCard                     // Con imagen y sección tipo default → tarjeta con imagen
              : OrderProductCard;                // Con imagen pero sección tipo Order → tarjeta solo texto (porque el tipo lo exige)

          return (
            <Grid item xs={12} sm={6} key={product.product_id || product.id}>
              <Box sx={{
                "& .MuiCard-root": {
                  backgroundColor: `${productBg} !important`,
                  boxShadow: `0 8px 20px rgba(0,0,0,0.12), 0 4px 12px ${buttonColor}80 !important`,
                  color: `${productText} !important`,
                  borderRadius: '20px !important',
                  '&:hover': {
                    transform: 'translateY(-4px) !important',
                    boxShadow: '0 8px 30px rgba(0,0,0,0.15) !important'
                  }
                },
                "& .MuiTypography-root": { color: `${productText} !important` },
                "& .MuiTypography-caption": {
                  color: `${isDarkMode ? '#AAAAAA' : '#666666'} !important`,
                  opacity: 0.8
                },
                "& .price-text": {
                  color: `${buttonColor} !important`,
                  fontWeight: 900,
                  fontSize: '1.2rem'
                },
                "& .MuiIconButton-root": {
                  backgroundColor: `${buttonColor} !important`,
                  color: `${getContrastColor(buttonColor)} !important`,
                  borderRadius: '12px !important',
                  width: '40px !important',
                  height: '40px !important',
                  '&:hover': {
                    backgroundColor: `${buttonColor} !important`,
                    opacity: 0.9
                  }
                }
              }}>
                <CardComponent
                  product={product}
                  onSelect={() => onProductSelect(product, section)}
                  buttonColorCards={buttonColor}
                  backgroundColorCards={productBg}
                  textColorCards={productText}
                />
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

// --- FOOTER FLOTANTE ---
const MenuFooter = ({ cart, isValidAuth, onCallWaiter, onOpenCart, menuConfig, cooldown }) => {
  const totalItems = cart.reduce((total, item) => total + item.quantity, 0);
  const totalPrice = cart.reduce((acc, curr) => acc + (curr.price * curr.quantity), 0);

  const callWaiterBg = menuConfig.productBackground || "#4CAF50";
  const callWaiterText = menuConfig.footer?.call_waiter_text_color || "#ffffff";
  const viewCartBg = menuConfig.footer?.view_cart_button_background || "#C5A059";
  const viewCartText = menuConfig.footer?.view_cart_button_text_color || "#ffffff";

  return (
    <Box sx={{
      position: 'sticky',
      bottom: 'calc(20px + env(safe-area-inset-bottom, 0px))',
      left: 0,
      right: 0,
      zIndex: 1100,
      display: 'flex',
      justifyContent: 'center',
      px: { xs: 1, sm: 2, md: 3 },
      mb: 1,
    }}>
      <Box sx={{
        width: '100%',
        maxWidth: 640,
        borderRadius: '20px',
        boxShadow: '0 -4px 20px rgba(0,0,0,0.15)',
        backgroundColor: menuConfig.darkMode ? 'rgba(30, 30, 30, 0.92)' : 'rgba(255, 255, 255, 0.92)',
        backdropFilter: 'blur(20px)',
        border: menuConfig.darkMode ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.05)',
        py: 1,
        px: { xs: 2, sm: 3 }
      }}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={6}>
            <Button
              variant="contained"
              onClick={onCallWaiter}
              disabled={!isValidAuth}
              startIcon={<NotificationsIcon />}
              sx={{
                backgroundColor: callWaiterBg,
                color: callWaiterText,
                fontWeight: 700,
                textTransform: 'none',
                borderRadius: '16px',
                px: 2,
                py: 1,
                width: '100%',
                boxShadow: `0 4px 12px ${callWaiterBg}40`,
                '&:hover': {
                  opacity: 0.9,
                  backgroundColor: callWaiterBg,
                  transform: 'translateY(-2px)',
                  boxShadow: `0 6px 16px ${callWaiterBg}60`
                },
                '&.Mui-disabled': {
                  backgroundColor: '#f3f4f6',
                  color: '#9ca3af'
                }
              }}
            >
              <Box sx={{ textAlign: 'left' }}>
                <Typography variant="caption" sx={{
                  display: 'block',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  fontSize: '0.55rem',
                  opacity: 0.8
                }}>
                  Llamar
                </Typography>
                <Typography variant="body2" sx={{
                  fontWeight: 800,
                  textTransform: 'uppercase',
                  fontSize: '0.8rem'
                }}>
                  Mesero {cooldown > 0 && `(${cooldown}s)`}
                </Typography>
              </Box>
            </Button>
          </Grid>

          <Grid item xs={6}>
            <Button
              variant="contained"
              onClick={onOpenCart}
              disabled={cart.length === 0 || !isValidAuth}
              startIcon={<ShoppingBagIcon />}
              sx={{
                backgroundColor: viewCartBg,
                color: viewCartText,
                borderRadius: '16px',
                px: 2,
                py: 1,
                width: '100%',
                fontWeight: 700,
                textTransform: 'none',
                '&:hover': {
                  opacity: 0.9,
                  transform: 'translateY(-2px)',
                  boxShadow: `0 6px 16px ${viewCartBg}60`
                },
                '&.Mui-disabled': {
                  backgroundColor: '#f3f4f6',
                  color: '#9ca3af'
                }
              }}
            >
              <Box sx={{ textAlign: 'left', position: 'relative' }}>
                <Typography variant="caption" sx={{
                  display: 'block',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  fontSize: '0.55rem',
                  opacity: 0.8
                }}>
                  Ver Carrito
                </Typography>
                <Typography variant="body2" sx={{
                  fontWeight: 800,
                  textTransform: 'uppercase',
                  fontSize: '0.8rem'
                }}>
                  $ {totalPrice.toLocaleString()}
                </Typography>
              </Box>
              <Badge
                badgeContent={totalItems}
                color="primary"
                sx={{
                  '& .MuiBadge-badge': {
                    backgroundColor: 'white',
                    color: viewCartBg,
                    fontWeight: 900,
                    fontSize: '0.55rem',
                    minWidth: '16px',
                    height: '16px',
                    top: 0,
                    right: -10
                  }
                }}
              />
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

// --- COMPONENTE PRINCIPAL ---

export default function MenuClients() {
  const [sessionCode, setSessionCode] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedVariants, setSelectedVariants] = useState({});
  const [selectedProductSectionStyles, setSelectedProductSectionStyles] = useState({});
  const [openDetailProduct, setOpenDetailProduct] = useState(false);
  const [isDescExpanded, setIsDescExpanded] = useState(false);
  const [zoomImage, setZoomImage] = useState(null);
  const [cart, setCart] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [loading, setLoading] = useState(true);
  const [menu, setMenu] = useState([]);
  const [menuConfig, setMenuConfig] = useState({ darkMode: false });
  const [filteredSections, setFilteredSections] = useState([]);
  const [isValidAuth, setIsValidAuth] = useState(false);
  const [coordinates, setCoordinates] = useState({ latitude: null, longitude: null });
  const [openCommentModal, setOpenCommentModal] = useState(false);
  const [openCodeModal, setOpenCodeModal] = useState(false); // Modal para código de sesión
  const [codeInput, setCodeInput] = useState("");
  const [showOrderReceivedAnimation, setShowOrderReceivedAnimation] = useState(false);
  const [showErrorAnimation, setShowErrorAnimation] = useState(false);
  const [messageError, setMessageError] = useState("");
  const [severity, setSeverity] = useState("error");
  const [showFloatingHeader, setShowFloatingHeader] = useState(false);
  // Estados para manejo de permisos
  const [permissionState, setPermissionState] = useState('prompt'); // 'prompt', 'granted', 'denied'
  const [checkingPermission, setCheckingPermission] = useState(true);
  const [cooldown, setCooldown] = useState(0);
  const cooldownTimerRef = useRef(null);

  // Nuevos estados para el modal mejorado de llamada
  const [selectedCallOption, setSelectedCallOption] = useState(null); // 'waiter', 'bill', null
  const [callMessage, setCallMessage] = useState('');
  const [surveyRedirectCountdown, setSurveyRedirectCountdown] = useState(null);

  // Estado para el modal de confirmación de pedir cuenta
  const [openBillConfirmModal, setOpenBillConfirmModal] = useState(false);
  const navigate = useNavigate();

  // Estados para manejo de código de mesa (error 0006)
  const [openTableCodeModal, setOpenTableCodeModal] = useState(false);
  const [tempTableCode, setTempTableCode] = useState('');
  const [pendingCallData, setPendingCallData] = useState(null); // Guarda { type, comment } para reintentar (para waiter/bill)
  const [pendingOrderData, setPendingOrderData] = useState(null); // Guarda datos de orden pendiente

  const [isBannerVisible, setIsBannerVisible] = useState(false);
  const [bannerHasBeenShown, setBannerHasBeenShown] = useState(false);

  const sectionRefs = useRef({});
  const headerRef = useRef(null);
  const ticking = useRef(false);
  const { tableNumber } = useParams();

  // Función para obtener el código de mesa guardado
  const getStoredTableCode = useCallback(() => {
    if (!tableNumber) return null;
    return localStorage.getItem(`table_code_${tableNumber}`);
  }, [tableNumber]);

  // Scroll optimizado con requestAnimationFrame
  useEffect(() => {
    const handleScroll = () => {
      if (!ticking.current) {
        window.requestAnimationFrame(() => {
          if (headerRef.current) {
            const headerBottom = headerRef.current.getBoundingClientRect().bottom;
            setShowFloatingHeader(headerBottom < 10);
          }
          ticking.current = false;
        });
        ticking.current = true;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    return () => {
      if (cooldownTimerRef.current) clearInterval(cooldownTimerRef.current);
    };
  }, []);

  // Nuevo WebSocket para escuchar el cierre de sesión en tiempo real
  useEffect(() => {
    if (!isValidAuth) return;

    const sessionId = localStorage.getItem("session_table");
    if (!sessionId) return;

    const wsUrl = `${urlWebSockets}/websocket_session_status/${sessionId}`;
    const ws = new WebSocket(wsUrl);

    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (data.notification_type === 'session_closed') {
          console.log("Sesión cerrada detectada por WS:", data);
          // La regla del backend requiere cerrarlo inmediatamente.
          ws.close();
          setSurveyRedirectCountdown(3);
        }
      } catch (err) {
        console.error("Error parseando mensaje WS:", err);
      }
    };

    return () => {
      // Limpieza en caso de desmontar el componente
      if (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING) {
        ws.close();
      }
    };
  }, [isValidAuth]);

  // Lógica de temporizador para redirección a la encuesta
  useEffect(() => {
    if (surveyRedirectCountdown === null) return;

    if (surveyRedirectCountdown <= 0) {
      navigate(`/survey?table_public_id=${tableNumber || "3test"}`);
      return;
    }

    const timerId = setTimeout(() => {
      setSurveyRedirectCountdown(prev => prev - 1);
    }, 1000);

    return () => clearTimeout(timerId);
  }, [surveyRedirectCountdown, navigate, tableNumber]);

  // Manejador del Banner Promocional
  useEffect(() => {
    if (
      !loading &&
      menuConfig?.promotionalBannerUrl &&
      !bannerHasBeenShown &&
      !openCodeModal &&
      !openTableCodeModal
    ) {
      const timer = setTimeout(() => {
        setIsBannerVisible(true);
        setBannerHasBeenShown(true);
      }, 500); // Pequeño retraso visual
      return () => clearTimeout(timer);
    }
  }, [loading, menuConfig?.promotionalBannerUrl, bannerHasBeenShown, openCodeModal, openTableCodeModal]);

  // Ajuste dinámico de fondo del body para evitar barras blancas en móviles y overscroll
  useEffect(() => {
    if (menuConfig.themeId) {
      const originalBg = document.body.style.backgroundColor;
      document.body.style.backgroundColor = '#00051e';
      return () => {
        document.body.style.backgroundColor = originalBg;
      };
    }
  }, [menuConfig.themeId]);

  const startCooldown = (seconds) => {
    setCooldown(seconds);
    if (cooldownTimerRef.current) clearInterval(cooldownTimerRef.current);
    cooldownTimerRef.current = setInterval(() => {
      setCooldown(prev => {
        if (prev <= 1) {
          clearInterval(cooldownTimerRef.current);
          cooldownTimerRef.current = null;
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const scrollToSection = (sectionName) => {
    if (sectionName === "Todo el menú") {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    const sectionElement = sectionRefs.current[sectionName];
    if (sectionElement) {
      const offset = 160;
      const elementPosition = sectionElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  const fetchMenu = useCallback(async () => {
    try {
      const response = await makeRequest(
        "POST",
        `menu_manager/public_menu?table_id=${tableNumber || "3test"}`,
        {},
        "application/json"
      );

      const sections = response.menu.sections || [];
      sections.sort((a, b) => (a.order || 0) - (b.order || 0));

      setMenu(response);
      setFilteredSections(sections);
      localStorage.setItem("public_id", response.restaurant_public_id);

      if (response.menu) {
        const bgColor = response.menu.background_color;
        const darkMode = bgColor ? (() => {
          const luma = (() => {
            const c = bgColor.substring(1);
            const rgb = parseInt(c, 16);
            const r = (rgb >> 16) & 0xff;
            const g = (rgb >> 8) & 0xff;
            const b = (rgb >> 0) & 0xff;
            return 0.2126 * r + 0.7152 * g + 0.0722 * b;
          })();
          return luma < 128;
        })() : false;

        setMenuConfig({
          header: response.menu.header_config || {},
          tableCode: response.menu.table_code_config || {},
          filter: response.menu.filter_config || {},
          footer: response.menu.footer_config || {},
          globalBackground: response.menu.background_color || '#f9fafb',
          globalButtons: response.menu.buttons_color || '#C5A059',
          productBackground: response.menu.product_background_color,
          productText: response.menu.product_text_color,
          sections: response.menu.sections || [],
          logoUrl: response.menu.logo_url,
          backgroundImageUrl: response.menu.background_image_url,
          promotionalBannerUrl: response.menu.promotional_banner_image_url,
          themeId: response.menu.theme_id || null,
          darkMode
        });
      }

      if (response.restaurant_public_id) {
        makeRequest(
          "GET",
          `restaurant_admin/public/measurement_id/${response.restaurant_public_id}`,
          null,
          "application/json"
        )
        .then((gaResp) => {
          if (gaResp && gaResp.google_analytics_measurement_id) {
            initGoogleAnalytics(gaResp.google_analytics_measurement_id);
          }
        })
        .catch((e) => console.error("Error fetching Google Analytics ID:", e));
      }

      setMessageError("");
    } catch (err) {
      console.error("Error fetching menu:", err);
      setMessageError("No pudimos cargar el menú en este momento.");
      setSeverity("error");
    }
  }, [tableNumber]);

  const requestLocation = useCallback(async () => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject("unsupported");
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (p) => {
          const coords = { latitude: p.coords.latitude, longitude: p.coords.longitude };
          setCoordinates(coords);
          resolve(coords);
        },
        (err) => {
          reject(err);
        },
        { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
      );
    });
  }, []);

  const createSession = useCallback(async (coords) => {
    let deviceFingerprint = localStorage.getItem("device_fingerprint") || getCookie("device_fingerprint");
    if (!deviceFingerprint) {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      deviceFingerprint = result.visitorId;
      localStorage.setItem("device_fingerprint", deviceFingerprint);
      setCookie("device_fingerprint", deviceFingerprint, 365);
    }
    const sessionBody = {
      start_time: new Date().toISOString(),
      end_time: new Date(Date.now() + 3600000).toISOString(),
      device_fingerprint: deviceFingerprint,
      table_public_id: tableNumber || "3test",
      session_token: localStorage.getItem("session_table"),
      latitude: coords.latitude,
      longitude: coords.longitude,
    };
    try {
      const response = await makeRequest("POST", "calls_router/create_session", sessionBody, "application/json");
      localStorage.setItem("session_table", response.session_token);
      setSessionCode(response.session_code);
      setIsValidAuth(true);
      return response;
    } catch (error) {
      setIsValidAuth(false);
      if (error.error_code === "0008") {
        setMessageError("❌ Estás muy lejos de la ubicación del restaurante.");
        setSeverity("error"); setShowErrorAnimation(true);
      }
      if (error.error_code === "0011") {
        let url = localStorage.getItem("public_id");
        console.log(url)
        navigate(`/linktree/${url}`, {
          state: {
            from: window.location.pathname,
            message:
              "Tu sesión ha expirado. Por favor inicia sesión nuevamente.",
          },
        });
      }
      if (error.error_code === "0010") setOpenCodeModal(true);
      throw error;
    }
  }, [tableNumber, navigate]);

  const confirmCodeInput = async () => {
    if (codeInput.length !== 4) return;
    try {
      const sessionBody = {
        start_time: new Date().toISOString(),
        end_time: new Date(Date.now() + 3600000).toISOString(),
        table_public_id: tableNumber || "3test",
        session_code: codeInput,
        device_fingerprint: localStorage.getItem("device_fingerprint"),
        latitude: coordinates.latitude,
        longitude: coordinates.longitude,
      };
      const response = await makeRequest("POST", "calls_router/create_session", sessionBody, "application/json");
      localStorage.setItem("session_table", response.session_token);
      setSessionCode(response.session_code);
      setOpenCodeModal(false);
      setIsValidAuth(true);
      fetchMenu();
    } catch (error) {
      setMessageError("❌ Código incorrecto.");
      setSeverity("error"); setShowErrorAnimation(true);
      // Limpiar código ingresado
      setCodeInput("");
    }
  };

  // Efecto para verificar el estado del permiso
  useEffect(() => {
    const checkPermission = async () => {
      setCheckingPermission(true);
      try {
        if (navigator.permissions && navigator.permissions.query) {
          const status = await navigator.permissions.query({ name: 'geolocation' });
          setPermissionState(status.state);

          status.onchange = () => {
            setPermissionState(status.state);
            if (status.state === 'granted') {
              window.location.reload();
            }
          };
        } else {
          setPermissionState('prompt');
        }
      } catch (error) {
        console.error("Error checking permission:", error);
        setPermissionState('prompt');
      } finally {
        setCheckingPermission(false);
      }
    };

    checkPermission();
  }, []);

  // Efecto principal para manejar el flujo según el estado del permiso
  useEffect(() => {
    if (checkingPermission) return;

    const init = async () => {
      setLoading(true);
      try {
        if (permissionState === 'granted') {
          const coords = await requestLocation();
          await Promise.allSettled([
            createSession(coords),
            fetchMenu()
          ]);
          setLoading(false);
        } else if (permissionState === 'prompt') {
          try {
            const coords = await requestLocation();
            await Promise.allSettled([
              createSession(coords),
              fetchMenu()
            ]);
            setLoading(false);
          } catch (error) {
            console.log("Usuario denegó en el prompt");
          }
        } else if (permissionState === 'denied') {
          setLoading(false);
        }
      } catch (error) {
        console.error("Error en init:", error);
        setLoading(false);
      }
    };

    init();
  }, [permissionState, checkingPermission, requestLocation, createSession, fetchMenu]);

  const addToCart = (product) => {
    const basePrice = product.discounted_price ? product.discounted_price : product.price;
    let extraPrice = 0;
    let variantString = "";
    let selected_detail_variants = [];

    if (product.is_complex && product.detail_variants) {
      const parts = [];
      Object.keys(selectedVariants).forEach(key => {
        const qty = selectedVariants[key];
        if (qty > 0) {
          const [gIdx, oIdx] = key.split('_');
          const groupName = product.detail_variants[gIdx]?.option_display_name;
          const option = product.detail_variants[gIdx]?.details[oIdx];
          if (option) {
            const lineTotal = Number(option.value || 0) * qty;
            extraPrice += lineTotal;
            let optionText = `${qty}x ${option.name}`;
            if (lineTotal > 0) {
              optionText += ` (+ $${lineTotal.toLocaleString()})`;
            }
            parts.push(`${groupName}: ${optionText}`);

            // Agregar a los variants seleccionados estructurados
            let existingGroup = selected_detail_variants.find(g => g.option_display_name === groupName);
            if (!existingGroup) {
              existingGroup = { option_display_name: groupName, details: [] };
              selected_detail_variants.push(existingGroup);
            }
            existingGroup.details.push({
              ...option,
              quantity: qty
            });
          }
        }
      });
      if (parts.length > 0) {
        // También añadir el costo base para más claridad en el string resumen
        parts.unshift(`Base: $${basePrice.toLocaleString()}`);
      }
      variantString = parts.length > 0 ? parts.join(" | ") : "";
    }

    const finalPrice = basePrice + extraPrice;
    const id = product.product_id || product.id;
    const activeVariants = Object.entries(selectedVariants).filter(([k, v]) => v > 0).sort();
    const cartItemId = product.is_complex
      ? `${id}_${activeVariants.map(([k, v]) => `${k}-${v}`).join("_")}`
      : id;

    let productSectionStyles = {};
    let buttonColorCards = menuConfig.globalButtons || '#C5A059';
    let backgroundColorCards = menuConfig.productBackground || (menuConfig.darkMode ? "#1E1E1E" : "#FFFFFF");
    let textColorCards = menuConfig.productText || (menuConfig.darkMode ? "#FFFFFF" : "#1A1A1A");
    let borderColor = productSectionStyles.product_border_color || menuConfig.globalButtons || '#C5A059';

    filteredSections.forEach(section => {
      const foundProduct = section.products.find(p =>
        p.product_id === id || p.id === id
      );
      if (foundProduct) {
        productSectionStyles = section.styles || {};
        buttonColorCards = section.button_color_cards || productSectionStyles.buttons_color || buttonColorCards;
        backgroundColorCards = section.background_color_cards || productSectionStyles.product_background_color || backgroundColorCards;
        textColorCards = section.text_color_cards || productSectionStyles.product_text_color || textColorCards;
        borderColor = productSectionStyles.product_border_color || borderColor;
      }
    });

    setCart((prev) => {
      const exists = prev.find(i => i.cartItemId === cartItemId);

      if (exists) {
        return prev.map(i =>
          i.cartItemId === cartItemId
            ? {
              ...i,
              quantity: i.quantity + quantity,
              sectionStyles: productSectionStyles,
              buttonColorCards,
              backgroundColorCards,
              textColorCards,
              borderColor
            }
            : i
        );
      }

      return [...prev, {
        ...product,
        product_id: id,
        cartItemId: cartItemId,
        variantString: variantString,
        detail_variants: selected_detail_variants,
        quantity,
        price: finalPrice,
        sectionStyles: productSectionStyles,
        buttonColorCards,
        backgroundColorCards,
        textColorCards,
        borderColor
      }];
    });

    setOpenDetailProduct(false);
    setQuantity(1);
    setSelectedVariants({});
  };

  // Función para manejar la llamada al mesero (con opciones)
  const handleCallWaiter = async (type, comment) => {
    let typeOfCall = 'normal_call';
    let finalComment = comment;

    if (type === 'bill') {
      typeOfCall = 'bill_order';
    } else if (type === 'waiter' && comment) {
      typeOfCall = 'commented_call';
    } else if (!type && comment) {
      typeOfCall = 'commented_call';
    }

    const storedTableCode = getStoredTableCode();

    const obj = {
      table_public_id: tableNumber || "3test",
      comment: finalComment,
      latitude: coordinates.latitude,
      longitude: coordinates.longitude,
      call_type: typeOfCall,
      session_token: localStorage.getItem("session_table"),
      code: storedTableCode || sessionCode,  // Usar código de mesa guardado o el código de sesión
      table_code: storedTableCode,           // Mantener por compatibilidad
      order: {
        products: [],
        total_price: 0
      }
    };

    try {
      await makeRequest("POST", `calls_router/notify_waiters`, obj, "application/json");
      setShowOrderReceivedAnimation(true);
      setOpenCommentModal(false);
      setSelectedCallOption(null);
      setCallMessage('');
      setIsCartOpen(false);
    } catch (error) {
      if (error.error_code === "0005" && error.value) {
        setMessageError(`Debes esperar ${error.value} segundos antes de llamar nuevamente.`);
        startCooldown(error.value);
        setShowErrorAnimation(true);
      } else if (error.error_code === "0006") {
        // Código de mesa inválido: guardar datos pendientes y abrir modal
        setPendingCallData({ type, comment });
        setOpenTableCodeModal(true);
        setOpenCommentModal(false);
      } else if (error.error_code === "0011") {
        let url = localStorage.getItem("public_id");
        console.log(url)
        navigate(`/linktree/${url}`, {
          state: {
            from: window.location.pathname,
            message:
              "Tu sesión ha expirado. Por favor inicia sesión nuevamente.",
          },
        });
      } else {
        setMessageError("Error al contactar al mesero.");
        setShowErrorAnimation(true);
      }
    }
  };

  // Función para manejar el envío de una orden (desde el carrito)
  const handleOrderCall = async () => {
    const total_price = cart.reduce((acc, curr) => acc + (curr.price * curr.quantity), 0);
    const storedTableCode = getStoredTableCode();

    const obj = {
      table_public_id: tableNumber || "3test",
      comment: "",
      latitude: coordinates.latitude,
      longitude: coordinates.longitude,
      call_type: "order_call",
      session_token: localStorage.getItem("session_table"),
      code: storedTableCode || sessionCode,  // Usar código de mesa guardado o el código de sesión
      table_code: storedTableCode,           // Mantener por compatibilidad
      order: {
        products: cart.map(item => ({
          product_id: item.product_id,
          name: item.name,
          quantity: item.quantity,
          price: item.price,
          pos_id: item.pos_id,
          is_complex: item.is_complex || false,
          detail_variants: item.detail_variants || []
        })),
        total_price: total_price
      }
    };

    // Construir comentario maestro a partir de carritos con variantes (productos complejos)
    let finalComment = "";
    const cartComments = [];
    cart.forEach(item => {
      if (item.is_complex && item.variantString) {
        cartComments.push(`[${item.name} x${item.quantity}] Variantes: ${item.variantString} | Total Final: $${(item.price * item.quantity).toLocaleString()}`);
      }
    });
    if (cartComments.length > 0) {
      finalComment = cartComments.join(" \n ");
    }
    obj.comment = finalComment;

    try {
      await makeRequest("POST", `calls_router/notify_waiters`, obj, "application/json");
      setShowOrderReceivedAnimation(true);
      setCart([]); // Vaciar carrito tras orden exitosa
      setIsCartOpen(false);
    } catch (error) {
      if (error.error_code === "0005" && error.value) {
        setMessageError(`Debes esperar ${error.value} segundos antes de llamar nuevamente.`);
        startCooldown(error.value);
        setShowErrorAnimation(true);
      } else if (error.error_code === "0006") {
        // Guardar que queremos hacer una orden y abrir modal de código
        setPendingOrderData(true); // Podría ser un objeto con más info si se requiere
        setOpenTableCodeModal(true);
        setIsCartOpen(false); // Opcional: cerrar carrito mientras se ingresa código
      } else if (error.error_code === "0011") {
        let url = localStorage.getItem("public_id");
        console.log(url)
        navigate(`/linktree/${url}`, {
          state: {
            from: window.location.pathname,
            message:
              "Tu sesión ha expirado. Por favor inicia sesión nuevamente.",
          },
        });
      } else {
        setMessageError("Error al enviar la orden.");
        setShowErrorAnimation(true);
      }
    }
  };

  // Función para confirmar el código de mesa ingresado
  const confirmTableCode = async () => {
    if (tempTableCode.length !== 4) return;

    // Guardar en localStorage
    localStorage.setItem(`table_code_${tableNumber}`, tempTableCode);

    // Reintentar acción pendiente
    try {
      if (pendingCallData) {
        await handleCallWaiter(pendingCallData.type, pendingCallData.comment);
        setPendingCallData(null);
      } else if (pendingOrderData) {
        await handleOrderCall();
        setPendingOrderData(null);
      }

      setOpenTableCodeModal(false);
      setTempTableCode('');
    } catch (error) {
      // Si hay error (por ejemplo código incorrecto), limpiar código
      setTempTableCode('');
      setMessageError("Código incorrecto. Intenta nuevamente.");
      setSeverity("error");
      setShowErrorAnimation(true);
    }
  };

  const handleProductSelect = (product, section = {}) => {
    setSelectedProduct(product);
    setSelectedVariants({});
    setSelectedProductSectionStyles({
      sectionStyles: section?.styles || {},
      buttonColorCards: section?.button_color_cards,
      backgroundColorCards: section?.background_color_cards,
      textColorCards: section?.text_color_cards,
      borderColor: section?.styles?.product_border_color
    });
    setOpenDetailProduct(true);
    setIsDescExpanded(false);
    setQuantity(1);
    setZoomImage(null);
  };

  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/`;
  }
  function getCookie(name) {
    return document.cookie.split("; ").find((row) => row.startsWith(name + "="))?.split("=")[1];
  }

  // Determinar si el botón de confirmar en el modal de llamada debe estar habilitado
  const isConfirmEnabled = (selectedCallOption !== null || callMessage.trim() !== '') && cooldown === 0;

  // Lógica de cálculo de precios en tiempo real para variantes
  const getBasePrice = () => {
    if (!selectedProduct) return 0;
    return selectedProduct.discounted_price ? selectedProduct.discounted_price : selectedProduct.price;
  };

  const getVariantsExtraPrice = () => {
    if (!selectedProduct || !selectedProduct.is_complex || !selectedProduct.detail_variants) return 0;
    let extra = 0;
    Object.keys(selectedVariants).forEach(key => {
      const qty = selectedVariants[key];
      if (qty > 0) {
        const [gIdx, oIdx] = key.split('_');
        const option = selectedProduct.detail_variants[gIdx]?.details[oIdx];
        if (option && option.value) {
          extra += Number(option.value) * qty;
        }
      }
    });
    return extra;
  };

  const finalUnitPrice = getBasePrice() + getVariantsExtraPrice();
  // En este formato multisexual por cantitades, no hay bloqueo de confirmación mandatorio
  const isComplexReady = true;

  // --- RENDERIZADO CONDICIONAL ---
  if (checkingPermission) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <CircularProgress sx={{ color: "#C5A059" }} />
      </Box>
    );
  }

  if (permissionState === 'denied') {
    return (
      <Box sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        px: 3,
        textAlign: 'center',
        backgroundColor: '#f9fafb'
      }}>
        {/* Ícono grande de ubicación denegada */}
        <Box sx={{
          width: 100,
          height: 100,
          borderRadius: '50%',
          backgroundColor: '#fee2e2',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 3,
          mt: 35
        }}>
          <span style={{ fontSize: 48 }}>📍🚫</span>
        </Box>

        <Typography variant="h5" sx={{ fontWeight: 800, mb: 2, color: '#1e293b' }}>
          Permiso de ubicación denegado
        </Typography>

        <Typography variant="body1" sx={{ mb: 4, color: '#475569', maxWidth: 400, lineHeight: 1.6 }}>
          Para usar el menú interactivo, necesitamos acceder a tu ubicación.
          Sigue estos pasos para activarla:
        </Typography>

        {/* Pasos */}
        <Box sx={{ textAlign: 'left', maxWidth: 380, width: '100%' }}>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 2.5 }}>
            <Box sx={{
              width: 28,
              height: 28,
              borderRadius: '50%',
              backgroundColor: '#C5A059',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 900,
              fontSize: 16,
              flexShrink: 0
            }}>1</Box>
            <Typography variant="body1" sx={{ color: '#334155' }}>
              Haz clic en el ícono del <strong>candado 🔒</strong> en la barra de direcciones (junto a la URL).
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 2.5 }}>
            <Box sx={{
              width: 28,
              height: 28,
              borderRadius: '50%',
              backgroundColor: '#C5A059',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 900,
              fontSize: 16,
              flexShrink: 0
            }}>2</Box>
            <Typography variant="body1" sx={{ color: '#334155' }}>
              En el menú, busca la sección <strong>"Ubicación"</strong> y cambia la opción a <strong>"Permitir"</strong>.
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 4 }}>
            <Box sx={{
              width: 28,
              height: 28,
              borderRadius: '50%',
              backgroundColor: '#C5A059',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 900,
              fontSize: 16,
              flexShrink: 0
            }}>3</Box>
            <Typography variant="body1" sx={{ color: '#334155' }}>
              La página se <strong>recargará automáticamente</strong> y podrás disfrutar del menú.
            </Typography>
          </Box>
        </Box>

        {/* GIF instructivo */}
        <Box
          component="img"
          src={eateryGif}
          alt="Instrucciones animadas"
          sx={{
            width: '100%',
            maxWidth: 380,
            borderRadius: 4,
            boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
            mt: 2,
            mb: 3,
          }}
        />

        <Typography variant="caption" sx={{ color: '#94a3b8', mt: 2 }}>
          ¿No funciona? Asegúrate de que la ubicación no esté bloqueada en la configuración del navegador.
        </Typography>
      </Box>
    );
  }

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <CircularProgress sx={{ color: "#C5A059" }} />
      </Box>
    );
  }

  if (messageError && filteredSections.length === 0) {
    return (
      <Box sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        px: 4,
        textAlign: 'center',
        backgroundColor: '#f9fafb'
      }}>
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#333' }}>
          {messageError}
        </Typography>
        <Button
          variant="contained"
          onClick={fetchMenu}
          sx={{
            backgroundColor: '#C5A059',
            color: '#ffffff',
            fontWeight: 700,
            py: 1.5,
            borderRadius: '12px',
            textTransform: 'none',
            fontSize: '1rem',
            boxShadow: '0 4px 12px rgba(197, 160, 89, 0.3)',
            '&:hover': { backgroundColor: '#B38E42' },
            px: 4
          }}
        >
          Reintentar cargar menú
        </Button>
      </Box>
    );
  }

  // Renderizado normal del menú
  return (
    <Box sx={{
      position: 'relative',
      minHeight: '100vh',
      backgroundColor: menuConfig.themeId ? '#00051e' : 'transparent'
    }}>
      {/* Imagen de fondo con blur (si existe) — Bloqueada cuando hay tema del mundial */}
      {menuConfig.backgroundImageUrl && !menuConfig.themeId && (
        <Box sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url(${menuConfig.backgroundImageUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          transform: 'scale(1.02)',
          zIndex: -1,
        }} />
      )}

      {/* Contenido principal */}
      <Box sx={{
        position: 'relative',
        zIndex: 1,
        // World Cup theme handles its own background — use dark stadium blue to blend and avoid white bars
        backgroundColor: menuConfig.themeId
          ? '#00051e'
          : menuConfig.backgroundImageUrl
            ? 'rgba(0,0,0,0.2)'
            : (menuConfig.darkMode ? "#121212" : "#FDFCFB"),
        minHeight: '100vh',
        pb: menuConfig.themeId ? 0 : '90px',
      }}>
        {menuConfig.themeId && worldCupThemeAssets[menuConfig.themeId] ? (
          // ══════════════════════════════════════════
          // WORLD CUP COLOMBIA THEME — full visual override
          // Business logic (cart, addToCart, etc.) unchanged
          // ══════════════════════════════════════════
          (() => {
            const wcTheme = worldCupThemeAssets[menuConfig.themeId];
            return (
              <>
                <WorldCupRenderer
                  sections={filteredSections}
                  theme={wcTheme}
                  logoUrl={menuConfig.logoUrl}
                  restaurantName={menu.restaurant_name}
                  onProductSelect={handleProductSelect}
                />
                <MenuFooter
                  cart={cart}
                  isValidAuth={isValidAuth}
                  onCallWaiter={() => setOpenCommentModal(true)}
                  onOpenCart={() => setIsCartOpen(true)}
                  menuConfig={{
                    ...menuConfig,
                    // Override footer colors to match the Colombia theme
                    globalButtons: wcTheme.yellow,
                    darkMode: true,
                    footer: {
                      ...menuConfig.footer,
                      view_cart_button_background: wcTheme.yellow,
                      view_cart_button_text_color: wcTheme.blue,
                      call_waiter_button_background: wcTheme.blue,
                      call_waiter_text_color: '#FFFFFF',
                    }
                  }}
                  cooldown={cooldown}
                />
              </>
            );
          })()
        ) : (
          <>
            {/* Placeholder para mini header */}
            {showFloatingHeader && <Box sx={{ height: '70px' }} />}

            {/* Header principal */}
            <div ref={headerRef}>
              <MenuHeader
                menuSections={menu.menu?.sections || []}
                sessionCode={sessionCode}
                onScrollToSection={scrollToSection}
                menuConfig={menuConfig}
                logoUrl={menuConfig.logoUrl}
                nameMenu={menu.restaurant_name}
              />
            </div>

            {/* Mini header flotante */}
            <MiniHeader
              menuSections={menu.menu?.sections || []}
              onScrollToSection={scrollToSection}
              menuConfig={menuConfig}
              show={showFloatingHeader}
            />

            <Container maxWidth="md" sx={{ mt: 3 }}>
              {filteredSections.map((section, idx) => (
                <Box
                  key={idx}
                  ref={(el) => (sectionRefs.current[section.name] = el)}
                >
                  <MenuSection
                    section={section}
                    onProductSelect={handleProductSelect}
                    isDarkMode={menuConfig.darkMode}
                    globalButtonColor={menuConfig.globalButtons}
                  />
                </Box>
              ))}
            </Container>

            <MenuFooter
              cart={cart}
              isValidAuth={isValidAuth}
              onCallWaiter={() => setOpenCommentModal(true)}
              onOpenCart={() => setIsCartOpen(true)}
              menuConfig={menuConfig}
              cooldown={cooldown}
            />
          </>
        )}

        {/* Modal de detalle de producto */}
        {menuConfig.themeId && worldCupThemeAssets[menuConfig.themeId] ? (
          <WorldCupProductModal
            open={openDetailProduct}
            onClose={() => setOpenDetailProduct(false)}
            product={selectedProduct}
            theme={worldCupThemeAssets[menuConfig.themeId]}
            quantity={quantity}
            setQuantity={setQuantity}
            selectedVariants={selectedVariants}
            setSelectedVariants={setSelectedVariants}
            onAddToCart={addToCart}
          />
        ) : (
          <Dialog
            open={openDetailProduct}
            onClose={() => setOpenDetailProduct(false)}
            fullWidth
            maxWidth="xs"
            PaperProps={{
              sx: {
                borderRadius: '28px',
                overflow: 'hidden',
                backgroundColor: menuConfig.darkMode ? '#1A1A1A' : '#FFFFFF',
                maxWidth: '500px !important',
                width: '95%',
                margin: 'auto',
                boxShadow: '0 24px 60px rgba(0,0,0,0.25)',
              },
            }}
          >
            {/* ---- HERO: imagen o gradiente con nombre y precio ---- */}
            <Box sx={{ position: 'relative' }}>
              {selectedProduct?.image_url ? (
                <Box 
                  onClick={() => selectedProduct.image_url && setZoomImage(selectedProduct.image_url)}
                  sx={{ 
                    width: '100%', 
                    height: '220px', 
                    overflow: 'hidden',
                    cursor: selectedProduct.image_url ? 'pointer' : 'default'
                  }}
                >
                  <img
                    src={selectedProduct.image_url}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    alt={selectedProduct?.name}
                  />
                  <Box sx={{
                    position: 'absolute', inset: 0,
                    background: 'linear-gradient(to top, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.1) 60%)',
                  }} />
                </Box>
              ) : (
                <Box sx={{
                  width: '100%', height: '140px',
                  background: `linear-gradient(135deg, ${selectedProductSectionStyles.buttonColorCards || menuConfig.globalButtons || '#C5A059'}22, ${selectedProductSectionStyles.buttonColorCards || menuConfig.globalButtons || '#C5A059'}55)`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  <RestaurantMenuIcon sx={{ fontSize: 56, color: selectedProductSectionStyles.buttonColorCards || menuConfig.globalButtons || '#C5A059', opacity: 0.6 }} />
                </Box>
              )}
              <Box sx={{
                position: 'absolute', bottom: 0, left: 0, right: 0,
                px: 2.5, pb: selectedProduct?.image_url ? 2 : 1.5, pt: 1,
              }}>
                <Typography variant="h5" sx={{
                  fontWeight: 900, lineHeight: 1.2,
                  color: selectedProduct?.image_url
                    ? '#FFFFFF'
                    : (selectedProductSectionStyles.textColorCards || menuConfig.productText || (menuConfig.darkMode ? '#FFF' : '#1A1A1A')),
                  textShadow: selectedProduct?.image_url ? '0 2px 8px rgba(0,0,0,0.5)' : 'none',
                }}>
                  {selectedProduct?.name}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                  <Typography variant="h6" sx={{
                    fontWeight: 900,
                    color: selectedProduct?.image_url ? '#FFD97D' : (selectedProductSectionStyles.buttonColorCards || menuConfig.globalButtons || '#C5A059'),
                    fontSize: '1.1rem',
                  }}>
                    ${(selectedProduct?.discounted_price || selectedProduct?.price || 0).toLocaleString()}
                  </Typography>
                  {selectedProduct?.discounted_price && (
                    <Typography variant="caption" sx={{
                      textDecoration: 'line-through',
                      color: selectedProduct?.image_url ? 'rgba(255,255,255,0.6)' : '#aaa',
                      fontWeight: 600,
                    }}>
                      ${(selectedProduct?.price || 0).toLocaleString()}
                    </Typography>
                  )}
                </Box>
              </Box>
              <IconButton
                onClick={() => setOpenDetailProduct(false)}
                sx={{
                  position: 'absolute', right: 10, top: 10,
                  color: '#ffffff', bgcolor: 'rgba(0,0,0,0.35)',
                  backdropFilter: 'blur(8px)', zIndex: 10,
                  '&:hover': { bgcolor: 'rgba(0,0,0,0.55)' },
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>

            <DialogContent sx={{ p: 0, display: 'flex', flexDirection: 'column', maxHeight: '60vh', overflowY: 'auto' }}>
              {selectedProduct?.description && (() => {
                const shouldTruncate = selectedProduct.description.length > 150;
                const displayText = isDescExpanded
                  ? selectedProduct.description
                  : shouldTruncate
                    ? `${selectedProduct.description.substring(0, 150)}...`
                    : selectedProduct.description;
                return (
                  <Box sx={{ px: 2.5, pt: 2, pb: selectedProduct?.is_complex ? 0 : 2 }}>
                    <Typography variant="body2" sx={{ color: menuConfig.darkMode ? '#CCCCCC' : '#555555', lineHeight: 1.6, fontWeight: 500 }}>
                      {displayText}{' '}
                      {shouldTruncate && (
                        <span
                          onClick={() => setIsDescExpanded(!isDescExpanded)}
                          style={{
                            color: selectedProductSectionStyles.buttonColorCards || menuConfig.globalButtons || '#C5A059',
                            cursor: 'pointer',
                            fontWeight: 800,
                            marginLeft: '4px',
                            textDecoration: 'underline'
                          }}
                        >
                          {isDescExpanded ? 'Ver menos' : 'Ver más'}
                        </span>
                      )}
                    </Typography>
                  </Box>
                );
              })()}

              {selectedProduct?.is_complex && selectedProduct?.detail_variants && (
                <Box sx={{ px: 2.5, pt: 2, pb: 1 }}>
                  {selectedProduct.detail_variants.map((group, groupIndex) => {
                    const mainColor = selectedProductSectionStyles.buttonColorCards
                      || selectedProductSectionStyles.sectionStyles?.buttons_color
                      || menuConfig.globalButtons || '#C5A059';
                    return (
                      <Box key={groupIndex} sx={{ mb: 2.5 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                          <Box sx={{ width: 4, height: 18, borderRadius: 2, bgcolor: mainColor }} />
                          <Typography variant="subtitle2" sx={{
                            fontWeight: 800, fontSize: '0.9rem',
                            color: menuConfig.darkMode ? '#FFFFFF' : '#1A1A1A',
                            textTransform: 'uppercase', letterSpacing: '0.5px',
                          }}>
                            {group.option_display_name}
                          </Typography>
                        </Box>
                        <Grid container spacing={1}>
                          {group.details.map((option, optionIndex) => {
                            const key = `${groupIndex}_${optionIndex}`;
                            const qty = selectedVariants[key] || 0;
                            const isSelected = qty > 0;
                            const hasPrice = Number(option.value || 0) > 0;
                            return (
                              <Grid item xs={12} sm={6} md={6} key={optionIndex}>
                                <Box 
                                  onClick={() => setSelectedVariants(prev => ({ ...prev, [key]: isSelected ? 0 : 1 }))}
                                  sx={{
                                  border: `2px solid ${isSelected ? mainColor : (menuConfig.darkMode ? 'rgba(255,255,255,0.12)' : '#E5E7EB')}`,
                                  borderRadius: '16px', overflow: 'hidden',
                                  backgroundColor: isSelected ? `${mainColor}12` : (menuConfig.darkMode ? 'rgba(255,255,255,0.03)' : '#FAFAFA'),
                                  transition: 'all 0.18s ease',
                                  height: '100%',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                  flexDirection: 'row',
                                  width: '100%',
                                  cursor: 'pointer'
                                }}>
                                  <Box sx={{ px: 1.5, py: 1.5, flexGrow: 1, textAlign: 'left' }}>
                                    <Typography sx={{ fontWeight: 700, fontSize: '0.85rem', color: menuConfig.darkMode ? '#F0F0F0' : '#1A1A1A', lineHeight: 1.3 }}>
                                      {option.name}
                                    </Typography>
                                    {hasPrice && (
                                      <Typography variant="caption" sx={{ fontWeight: 800, color: mainColor, display: 'block', mt: 0.3 }}>
                                        +${Number(option.value).toLocaleString()}
                                      </Typography>
                                    )}
                                  </Box>
                                  <Box sx={{ pr: 1 }}>
                                    <Checkbox 
                                      checked={isSelected}
                                      disableRipple
                                      sx={{
                                        color: menuConfig.darkMode ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
                                        '&.Mui-checked': {
                                          color: mainColor,
                                        },
                                      }}
                                    />
                                  </Box>
                                </Box>
                              </Grid>
                            );
                          })}
                        </Grid>
                      </Box>
                    );
                  })}
                </Box>
              )}
            </DialogContent>

            {/* Barra inferior: cantidad + agregar */}
            <Box sx={{
              px: 2.5, py: 2,
              borderTop: `1px solid ${menuConfig.darkMode ? 'rgba(255,255,255,0.08)' : '#F0F0F0'}`,
              backgroundColor: menuConfig.darkMode ? '#1A1A1A' : '#FFFFFF',
              display: 'flex', alignItems: 'center', gap: 2,
            }}>
              <Box sx={{
                display: 'flex', alignItems: 'center', gap: 0.5,
                border: `1.5px solid ${selectedProductSectionStyles.buttonColorCards || menuConfig.globalButtons || '#C5A059'}`,
                borderRadius: '14px', px: 0.5,
              }}>
                <IconButton size="small"
                  onClick={() => setQuantity(Math.max(1, quantity - 1))}
                  sx={{ color: selectedProductSectionStyles.buttonColorCards || menuConfig.globalButtons || '#C5A059', '&:active': { transform: 'scale(0.9)' } }}
                >
                  <RemoveIcon fontSize="small" />
                </IconButton>
                <Typography sx={{ fontWeight: 900, fontSize: '1.1rem', minWidth: '28px', textAlign: 'center', color: menuConfig.darkMode ? '#FFFFFF' : '#1A1A1A' }}>
                  {quantity}
                </Typography>
                <IconButton size="small"
                  onClick={() => setQuantity(quantity + 1)}
                  sx={{ color: selectedProductSectionStyles.buttonColorCards || menuConfig.globalButtons || '#C5A059', '&:active': { transform: 'scale(0.9)' } }}
                >
                  <AddIcon fontSize="small" />
                </IconButton>
              </Box>
              <Button
                fullWidth variant="contained"
                disabled={!isComplexReady}
                onClick={() => addToCart(selectedProduct)}
                sx={{
                  backgroundColor: selectedProductSectionStyles.buttonColorCards
                    || selectedProductSectionStyles.sectionStyles?.buttons_color
                    || menuConfig.globalButtons || '#C5A059',
                  color: getContrastColor(selectedProductSectionStyles.buttonColorCards
                    || selectedProductSectionStyles.sectionStyles?.buttons_color
                    || menuConfig.globalButtons || '#C5A059'),
                  py: 1.6, fontWeight: 800, borderRadius: '14px',
                  fontSize: '1rem', textTransform: 'none',
                  boxShadow: `0 6px 16px rgba(${hexToRgb(selectedProductSectionStyles.buttonColorCards || menuConfig.globalButtons || '#C5A059')}, 0.3)`,
                  '&:hover': { opacity: 0.92 },
                  '&.Mui-disabled': {
                    backgroundColor: menuConfig.darkMode ? 'rgba(255,255,255,0.08)' : '#E5E7EB',
                    color: menuConfig.darkMode ? 'rgba(255,255,255,0.25)' : '#9CA3AF',
                  }
                }}
              >
                Agregar • ${(finalUnitPrice * quantity).toLocaleString()}
              </Button>
            </Box>
          </Dialog>
        )}

        {/* Zoom Image Dialog */}
        <Dialog 
          open={!!zoomImage} 
          onClose={() => setZoomImage(null)} 
          maxWidth="md" 
          PaperProps={{ sx: { bgcolor: 'transparent', boxShadow: 'none', overflow: 'hidden' } }}
        >
          <Box sx={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', bgcolor: 'rgba(0,0,0,0.9)', p: 1, borderRadius: '16px', border: `2px solid ${selectedProductSectionStyles.buttonColorCards || menuConfig.globalButtons || '#C5A059'}` }}>
            <img src={zoomImage} style={{ maxWidth: '100%', maxHeight: '85vh', objectFit: 'contain', borderRadius: '12px' }} alt="Zoom" />
            <IconButton
              onClick={() => setZoomImage(null)}
              sx={{ position: 'absolute', right: 15, top: 15, color: selectedProductSectionStyles.buttonColorCards || menuConfig.globalButtons || '#C5A059', bgcolor: 'rgba(0,0,0,0.7)', border: `1px solid ${selectedProductSectionStyles.buttonColorCards || menuConfig.globalButtons || '#C5A059'}`, '&:hover': { bgcolor: selectedProductSectionStyles.buttonColorCards || menuConfig.globalButtons || '#C5A059', color: '#000' } }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </Dialog>

        {/* Modal de llamada mejorado (nuevo diseño) */}

        <Dialog
          open={openCommentModal}
          onClose={() => {
            setOpenCommentModal(false);
            setSelectedCallOption(null);
            setCallMessage('');
          }}
          fullWidth
          maxWidth="xs"
          PaperProps={{
            sx: {
              borderRadius: '28px 28px 16px 16px',
              overflow: 'hidden',
              backgroundColor: 'transparent',
              boxShadow: 'none',
              margin: 0,
              position: 'fixed',
              bottom: 0,
              left: 0,
              right: 0,
              maxWidth: '480px',
              mx: 'auto',
            }
          }}
          BackdropProps={{
            sx: {
              backgroundColor: 'rgba(0,0,0,0.5)',
              backdropFilter: 'blur(4px)'
            }
          }}
        >
          <Box sx={{
            backgroundColor: menuConfig.darkMode ? 'rgba(30,30,30,0.95)' : 'rgba(255,255,255,0.95)',
            backdropFilter: 'blur(20px)',
            border: `1px solid ${menuConfig.globalButtons}20`,
            borderRadius: '28px 28px 16px 16px',
            overflow: 'hidden',
          }}>
            {/* Handle */}
            <Box sx={{ display: 'flex', justifyContent: 'center', pt: 2 }}>
              <Box sx={{ width: 40, height: 4, bgcolor: `${menuConfig.globalButtons}60`, borderRadius: 2 }} />
            </Box>

            {/* Título */}
            <Box sx={{ px: 3, pt: 2, pb: 2, textAlign: 'center' }}>
              <Typography variant="h5" sx={{ fontWeight: 800, color: menuConfig.darkMode ? '#FFFFFF' : '#1A1A1A' }}>
                ¿Cómo podemos ayudarte?
              </Typography>
              <Typography variant="body2" sx={{ color: menuConfig.darkMode ? '#AAAAAA' : '#666666', mt: 0.5 }}>
                Selecciona una opción para ser atendido
              </Typography>
            </Box>

            {/* Opciones */}
            <Box sx={{ px: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
              {/* Llamar Mesero */}
              <Button
                fullWidth
                onClick={() => setSelectedCallOption('waiter')}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  p: 2,
                  borderRadius: 3,
                  backgroundColor: selectedCallOption === 'waiter' ? `${menuConfig.globalButtons}20` : 'transparent',
                  border: `1px solid ${selectedCallOption === 'waiter' ? menuConfig.globalButtons : `${menuConfig.globalButtons}40`}`,
                  color: menuConfig.darkMode ? '#FFFFFF' : '#1A1A1A',
                  textTransform: 'none',
                  '&:hover': {
                    backgroundColor: `${menuConfig.globalButtons}20`,
                    borderColor: menuConfig.globalButtons,
                  }
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    bgcolor: menuConfig.globalButtons,
                    color: '#FFFFFF',
                  }}>
                    <NotificationsActiveIcon />
                  </Box>
                  <Box sx={{ textAlign: 'left' }}>
                    <Typography sx={{ fontWeight: 700 }}>Llamar Mesero</Typography>
                    <Typography variant="caption" sx={{ color: menuConfig.darkMode ? '#AAAAAA' : '#666666' }}>
                      Asistencia rápida en tu mesa
                    </Typography>
                  </Box>
                </Box>
                <ChevronRightIcon sx={{ color: menuConfig.globalButtons, opacity: 0.7 }} />
              </Button>

              {/* Pedir la Cuenta */}
              <Button
                fullWidth
                onClick={() => setSelectedCallOption('bill')}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  p: 2,
                  borderRadius: 3,
                  backgroundColor: selectedCallOption === 'bill' ? `${menuConfig.globalButtons}20` : 'transparent',
                  border: `1px solid ${selectedCallOption === 'bill' ? menuConfig.globalButtons : `${menuConfig.globalButtons}40`}`,
                  color: menuConfig.darkMode ? '#FFFFFF' : '#1A1A1A',
                  textTransform: 'none',
                  '&:hover': {
                    backgroundColor: `${menuConfig.globalButtons}20`,
                    borderColor: menuConfig.globalButtons,
                  }
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    bgcolor: menuConfig.darkMode ? '#2A2A2A' : '#F0F0F0',
                    color: menuConfig.globalButtons,
                    border: `1px solid ${menuConfig.globalButtons}40`,
                  }}>
                    <ReceiptLongIcon />
                  </Box>
                  <Box sx={{ textAlign: 'left' }}>
                    <Typography sx={{ fontWeight: 700 }}>Pedir la Cuenta</Typography>
                    <Typography variant="caption" sx={{ color: menuConfig.darkMode ? '#AAAAAA' : '#666666' }}>
                      Solicita el total de tu consumo
                    </Typography>
                  </Box>
                </Box>
                <ChevronRightIcon sx={{ color: menuConfig.darkMode ? '#888' : '#AAA' }} />
              </Button>

              {/* Área de mensaje personalizado - Solo visible si se selecciona "Llamar Mesero" */}
              {selectedCallOption === 'waiter' && (
                <Box sx={{ mt: 4, pt: 3, borderTop: `1px solid ${menuConfig.darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}` }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                    <ChatBubbleIcon sx={{ color: menuConfig.globalButtons, fontSize: 20 }} />
                    <Typography sx={{ fontWeight: 600, color: menuConfig.darkMode ? '#FFFFFF' : '#1A1A1A' }}>
                      Enviar Mensaje
                    </Typography>
                  </Box>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    placeholder="Ej: ¿Podrías traer más servilletas?"
                    value={callMessage}
                    onChange={(e) => setCallMessage(e.target.value)}
                    variant="outlined"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 3,
                        backgroundColor: menuConfig.darkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
                        color: menuConfig.darkMode ? '#FFFFFF' : '#1A1A1A',
                        '& fieldset': {
                          borderColor: menuConfig.darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
                        },
                        '&:hover fieldset': {
                          borderColor: menuConfig.globalButtons,
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: menuConfig.globalButtons,
                        }
                      }
                    }}
                  />
                </Box>
              )}
            </Box>

            {/* Botones de acción */}
            <Box sx={{ p: 3, display: 'flex', gap: 2 }}>
              <Button
                fullWidth
                variant="outlined"
                onClick={() => {
                  setOpenCommentModal(false);
                  setSelectedCallOption(null);
                  setCallMessage('');
                }}
                sx={{
                  borderColor: menuConfig.darkMode ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
                  color: menuConfig.darkMode ? '#FFFFFF' : '#1A1A1A',
                  py: 1.8,
                  borderRadius: 3,
                  fontWeight: 600,
                  '&:hover': {
                    borderColor: menuConfig.globalButtons,
                    backgroundColor: 'transparent',
                  }
                }}
              >
                Cancelar
              </Button>
              <Button
                fullWidth
                variant="contained"
                disabled={!isConfirmEnabled}
                onClick={() => {
                  if (selectedCallOption === 'bill') {
                    // Mostrar modal de confirmación para pedir cuenta
                    setOpenBillConfirmModal(true);
                  } else {
                    // Para 'waiter' o solo mensaje, proceder directamente
                    let type = null;
                    if (selectedCallOption === 'waiter') type = 'waiter';
                    handleCallWaiter(type, callMessage);
                  }
                }}
                sx={{
                  backgroundColor: menuConfig.globalButtons,
                  color: '#FFFFFF',
                  py: 1.8,
                  borderRadius: 3,
                  fontWeight: 700,
                  boxShadow: `0 8px 16px ${menuConfig.globalButtons}40`,
                  '&:hover': {
                    backgroundColor: menuConfig.globalButtons,
                    opacity: 0.9,
                  },
                  '&.Mui-disabled': {
                    backgroundColor: menuConfig.darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
                    color: menuConfig.darkMode ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
                  }
                }}
              >
                Confirmar Envío {cooldown > 0 && `(${cooldown}s)`}
              </Button>
            </Box>
            <Box sx={{ height: 8 }} /> {/* Espacio seguro */}
          </Box>
        </Dialog>

        {/* Modal de confirmación para pedir cuenta (con estilos dinámicos) */}
        <CustomDialog open={openBillConfirmModal} onClose={() => setOpenBillConfirmModal(false)}>
          <CustomDialogTitle sx={{ textAlign: 'center', color: '#000000', fontWeight: 700 }}>
            <WarningIcon sx={{ fontSize: 40, color: menuConfig.globalButtons || '#C5A059', mb: 1 }} />
            <Typography variant="h6" sx={{ fontWeight: 800, color: menuConfig.darkMode ? '#FFFFFF' : '#1A1A1A' }}>
              ¿Estás seguro?
            </Typography>
          </CustomDialogTitle>
          <CustomDialogContent>
            <DialogContentText sx={{ textAlign: 'center', color: menuConfig.darkMode ? '#AAAAAA' : '#666666', fontWeight: 500 }}>
              Al solicitar la cuenta, el mesero procesará el pago y se cerrará tu mesa. ¿Deseas continuar?
            </DialogContentText>
          </CustomDialogContent>
          <CustomDialogActions sx={{ justifyContent: 'center', gap: 2, pb: 3 }}>
            <Button
              onClick={() => setOpenBillConfirmModal(false)}
              variant="outlined"
              sx={{
                borderColor: menuConfig.globalButtons || '#C5A059',
                color: menuConfig.globalButtons || '#C5A059',
                px: 4,
                py: 1,
                fontWeight: 700,
                borderRadius: '12px',
                '&:hover': {
                  borderColor: menuConfig.globalButtons || '#B38E42',
                  backgroundColor: 'transparent',
                }
              }}
            >
              Cancelar
            </Button>
            <Button
              onClick={() => {
                setOpenBillConfirmModal(false);
                handleCallWaiter('bill', callMessage);
              }}
              variant="contained"
              sx={{
                backgroundColor: menuConfig.globalButtons || '#C5A059',
                color: getContrastColor(menuConfig.globalButtons || '#C5A059'),
                px: 4,
                py: 1,
                fontWeight: 700,
                borderRadius: '12px',
                boxShadow: `0 8px 16px ${menuConfig.globalButtons}40`,
                '&:hover': {
                  backgroundColor: menuConfig.globalButtons || '#B38E42',
                  opacity: 0.9,
                }
              }}
            >
              Sí, pedir cuenta
            </Button>
          </CustomDialogActions>
        </CustomDialog>

        {/* Modal para ingresar código de mesa (error 0006) con mejoras de foco */}
        <CustomDialog open={openTableCodeModal} onClose={() => setOpenTableCodeModal(false)}>
          <CustomDialogTitle sx={{ textAlign: 'center', color: '#000000', fontWeight: 700 }}>
            🔐 Código de Mesa
          </CustomDialogTitle>
          <CustomDialogContent>
            <DialogContentText sx={{ textAlign: 'center', mb: 3, color: '#333333', fontWeight: 600 }}>
              Por favor, ingresa el código de seguridad de tu mesa.
              Si no lo tienes, consúltalo con algún mesero.
            </DialogContentText>
            <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
              {[0, 1, 2, 3].map((i) => (
                <TextField
                  key={i}
                  id={`table-code-box-${i}`}
                  inputProps={{
                    maxLength: 1,
                    inputMode: 'numeric',
                    pattern: '[0-9]*',
                    style: {
                      textAlign: "center",
                      fontSize: "1.8rem",
                      fontWeight: '900',
                      color: '#000000',
                      backgroundColor: '#F5F5F5'
                    }
                  }}
                  value={tempTableCode[i] || ""}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (/^\d?$/.test(val)) {
                      const updated = tempTableCode.split("");
                      updated[i] = val;
                      setTempTableCode(updated.join(""));
                      // Auto-focus a la siguiente casilla si se ingresó un dígito
                      if (val && i < 3) {
                        document.getElementById(`table-code-box-${i + 1}`)?.focus();
                      }
                    }
                  }}
                  onKeyDown={(e) => {
                    // Si se presiona Backspace y el campo está vacío, mover foco al anterior
                    if (e.key === 'Backspace' && !tempTableCode[i] && i > 0) {
                      document.getElementById(`table-code-box-${i - 1}`)?.focus();
                    }
                  }}
                  sx={{
                    width: "65px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      "& fieldset": { border: '2px solid #000000' },
                      "&:hover fieldset": { borderColor: '#333333' },
                      "&.Mui-focused fieldset": { borderColor: '#000000' },
                    },
                    "& .MuiInputBase-input": { WebkitTextFillColor: "#000000" }
                  }}
                />
              ))}
            </Box>
          </CustomDialogContent>
          <CustomDialogActions sx={{ justifyContent: 'center', pb: 3 }}>
            <Button
              onClick={confirmTableCode}
              variant="contained"
              disabled={tempTableCode.length !== 4}
              sx={{
                backgroundColor: '#C5A059',
                color: '#ffffff',
                px: 6,
                py: 1.2,
                fontWeight: 800,
                borderRadius: '12px',
                '&:hover': { backgroundColor: '#B38E42' },
                '&.Mui-disabled': { backgroundColor: '#f3f4f6', color: '#9ca3af' }
              }}
            >
              Validar y Reintentar
            </Button>
          </CustomDialogActions>
        </CustomDialog>

        {/* Modal de código de sesión (existente) con mejoras de foco */}
        <CustomDialog open={openCodeModal} onClose={() => { }}>
          <CustomDialogTitle sx={{ textAlign: 'center', color: '#000000', fontWeight: 700 }}>
            🔐 Código de Mesa
          </CustomDialogTitle>
          <CustomDialogContent>
            <DialogContentText sx={{ textAlign: 'center', mb: 3, color: '#333333', fontWeight: 600 }}>
              Ingresa el código de tu mesa para continuar.
            </DialogContentText>
            <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
              {[0, 1, 2, 3].map((i) => (
                <TextField
                  key={i}
                  id={`code-box-${i}`}
                  inputProps={{
                    maxLength: 1,
                    inputMode: 'numeric',
                    pattern: '[0-9]*',
                    style: {
                      textAlign: "center",
                      fontSize: "1.8rem",
                      fontWeight: '900',
                      color: '#000000',
                      backgroundColor: '#F5F5F5'
                    }
                  }}
                  value={codeInput[i] || ""}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (/^\d?$/.test(val)) {
                      const updated = codeInput.split("");
                      updated[i] = val;
                      setCodeInput(updated.join(""));
                      if (val && i < 3) {
                        document.getElementById(`code-box-${i + 1}`)?.focus();
                      }
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Backspace' && !codeInput[i] && i > 0) {
                      document.getElementById(`code-box-${i - 1}`)?.focus();
                    }
                  }}
                  sx={{
                    width: "65px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      "& fieldset": { border: '2px solid #000000' },
                      "&:hover fieldset": { borderColor: '#333333' },
                      "&.Mui-focused fieldset": { borderColor: '#000000' },
                    },
                    "& .MuiInputBase-input": { WebkitTextFillColor: "#000000" }
                  }}
                />
              ))}
            </Box>
          </CustomDialogContent>
          <CustomDialogActions sx={{ justifyContent: 'center', pb: 3 }}>
            <Button
              onClick={confirmCodeInput}
              variant="contained"
              disabled={codeInput.length !== 4}
              sx={{
                backgroundColor: '#C5A059',
                color: '#ffffff',
                px: 6,
                py: 1.2,
                fontWeight: 800,
                borderRadius: '12px',
                '&:hover': { backgroundColor: '#B38E42' },
                '&.Mui-disabled': { backgroundColor: '#f3f4f6', color: '#9ca3af' }
              }}
            >
              Validar
            </Button>
          </CustomDialogActions>
        </CustomDialog>

        {/* Drawer del carrito */}
        <Drawer
          anchor="right"
          open={isCartOpen}
          onClose={() => setIsCartOpen(false)}
          PaperProps={{
            sx: {
              width: { xs: '100%', sm: 420 },
              borderTopLeftRadius: '28px',
              borderBottomLeftRadius: '28px',
              backgroundColor: menuConfig.globalBackground || (menuConfig.darkMode ? "#121212" : "#FDFCFB")
            }
          }}
        >
          <Box sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            backgroundColor: menuConfig.globalBackground || (menuConfig.darkMode ? "#121212" : "#FDFCFB")
          }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
              <Typography variant="h5" fontWeight={900} sx={{
                color: menuConfig.productText || (menuConfig.darkMode ? "#FFFFFF" : "#1A1A1A")
              }}>
                Mi Pedido
              </Typography>
              <IconButton onClick={() => setIsCartOpen(false)} sx={{ color: menuConfig.globalButtons || '#C5A059' }}>
                <CloseIcon />
              </IconButton>
            </Box>

            <Divider sx={{ mb: 3, borderColor: menuConfig.darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)' }} />

            <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>
              {cart.length === 0 ? (
                <Box sx={{ textAlign: 'center', mt: 15 }}>
                  <ShoppingBagIcon sx={{ fontSize: 100, color: menuConfig.darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)', mb: 2 }} />
                  <Typography sx={{ color: menuConfig.productText || (menuConfig.darkMode ? "#FFFFFF" : "#1A1A1A"), fontWeight: 600 }}>
                    Carrito vacío
                  </Typography>
                </Box>
              ) : (
                cart.map((item) => (
                  <Box key={item.cartItemId || item.product_id} sx={{
                    display: 'flex',
                    gap: 2,
                    mb: 2.5,
                    p: 2,
                    borderRadius: '20px',
                    border: `1.5px solid ${item.borderColor || menuConfig.globalButtons || '#C5A059'}`,
                    backgroundColor: item.backgroundColorCards || (menuConfig.darkMode ? "#1E1E1E" : "#FFFFFF"),
                  }}>
                    <Box sx={{ width: 85, minWidth: 85, borderRadius: '12px', overflow: 'hidden' }}>
                      <Box sx={{ width: '100%', paddingTop: '100%', position: 'relative' }}>
                        <img
                          src={item.image_url || imagenLocal}
                          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover' }}
                          alt={item.name}
                        />
                      </Box>
                    </Box>

                    <Box sx={{ flexGrow: 1 }}>
                      <Typography variant="subtitle1" fontWeight={800} sx={{ color: item.textColorCards || (menuConfig.darkMode ? "#FFFFFF" : "#1A1A1A"), mb: 0.5 }}>
                        {item.name}
                      </Typography>

                      {item.variantString && (
                        <Typography variant="caption" sx={{ color: item.textColorCards || (menuConfig.darkMode ? "#FFFFFF" : "#1A1A1A"), opacity: 0.8, display: 'block', mb: 1, lineHeight: 1.2 }}>
                          {item.variantString}
                        </Typography>
                      )}

                      <Typography variant="body1" sx={{ color: item.buttonColorCards || menuConfig.globalButtons || '#C5A059', fontWeight: 900, mb: 0.5 }}>
                        ${(item.price * item.quantity).toLocaleString()}
                      </Typography>

                      <Typography variant="caption" sx={{ color: item.textColorCards || (menuConfig.darkMode ? "#FFFFFF" : "#1A1A1A"), opacity: 0.7, display: 'block', mb: 1 }}>
                        ${item.price.toLocaleString()} c/u
                      </Typography>

                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', bgcolor: menuConfig.darkMode ? '#333' : '#f5f5f5', borderRadius: '10px', px: 1 }}>
                          <IconButton size="small" onClick={() => setCart(cart.map(i => i.cartItemId === item.cartItemId ? { ...i, quantity: Math.max(1, i.quantity - 1) } : i))}>
                            <RemoveIcon fontSize="small" sx={{ color: item.buttonColorCards || menuConfig.globalButtons || '#C5A059' }} />
                          </IconButton>
                          <Typography sx={{ mx: 1.5, fontWeight: 900, color: item.textColorCards || (menuConfig.darkMode ? "#FFFFFF" : "#1A1A1A") }}>
                            {item.quantity}
                          </Typography>
                          <IconButton size="small" onClick={() => setCart(cart.map(i => i.cartItemId === item.cartItemId ? { ...i, quantity: i.quantity + 1 } : i))}>
                            <AddIcon fontSize="small" sx={{ color: item.buttonColorCards || menuConfig.globalButtons || '#C5A059' }} />
                          </IconButton>
                        </Box>
                        <IconButton size="small" onClick={() => setCart(cart.filter(i => i.cartItemId !== item.cartItemId))}>
                          <DeleteOutlineIcon fontSize="small" sx={{ color: item.buttonColorCards || menuConfig.globalButtons || '#C5A059' }} />
                        </IconButton>
                      </Box>
                    </Box>
                  </Box>
                ))
              )}
            </Box>

            {cart.length > 0 && (
              <Box sx={{ mt: 'auto', pt: 3 }}>
                <Divider sx={{ mb: 2.5, borderColor: menuConfig.darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)' }} />
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 4 }}>
                  <Typography variant="h5" fontWeight={700} sx={{ color: menuConfig.productText || (menuConfig.darkMode ? "#FFFFFF" : "#1A1A1A") }}>
                    Total
                  </Typography>
                  <Typography variant="h5" fontWeight={900} sx={{ color: menuConfig.globalButtons || '#C5A059' }}>
                    ${cart.reduce((acc, curr) => acc + (curr.price * curr.quantity), 0).toLocaleString()}
                  </Typography>
                </Box>

                <Button
                  fullWidth
                  variant="contained"
                  onClick={handleOrderCall}
                  sx={{
                    backgroundColor: menuConfig.footer?.view_cart_button_background || '#C5A059',
                    color: getContrastColor(menuConfig.footer?.view_cart_button_background || '#C5A059'),
                    py: 2.2,
                    borderRadius: '18px',
                    fontWeight: 900,
                    fontSize: '1.1rem',
                    boxShadow: `0 8px 20px rgba(${hexToRgb(menuConfig.footer?.view_cart_button_background || '#C5A059')}, 0.25)`,
                    '&:hover': { opacity: 0.9 }
                  }}
                >
                  Confirmar Orden {cooldown > 0 && `(${cooldown}s)`}
                </Button>

                <Typography variant="caption" sx={{ mt: 2, textAlign: 'center', display: 'block', color: menuConfig.darkMode ? '#aaa' : '#666', fontWeight: 500 }}>
                  Al confirmar, un mesero recibirá tu pedido
                </Typography>
              </Box>
            )}
          </Box>
        </Drawer>

        <Snackbar open={showOrderReceivedAnimation} autoHideDuration={2000} onClose={() => setShowOrderReceivedAnimation(false)}>
          <Alert severity="success" variant="filled" action={<IconButton size="small" color="inherit" onClick={() => setShowOrderReceivedAnimation(false)}><CloseIcon fontSize="small" /></IconButton>}>
            ¡Llamado enviado!
          </Alert>
        </Snackbar>

        <Snackbar open={showErrorAnimation} autoHideDuration={2000} onClose={() => setShowErrorAnimation(false)}>
          <Alert severity={severity} variant="filled" action={<IconButton size="small" color="inherit" onClick={() => setShowErrorAnimation(false)}><CloseIcon fontSize="small" /></IconButton>}>
            {messageError}
          </Alert>
        </Snackbar>

        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 9999, display: 'flex', flexDirection: 'column', gap: 2, px: 3, textAlign: 'center' }}
          open={surveyRedirectCountdown !== null}
        >
          <CircularProgress color="inherit" />
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Tu sesión ha terminado.</Typography>
          <Typography variant="body1">Redireccionando a la encuesta en {surveyRedirectCountdown}s...</Typography>
        </Backdrop>

        <PromotionalBannerModal
          imageUrl={menuConfig?.promotionalBannerUrl}
          isVisible={isBannerVisible}
          onClose={() => setIsBannerVisible(false)}
        />
      </Box>
    </Box>
  );
}